enum VehicleLoanFuelTypeLabel {
  DIESEL = 'DIESEL',
  DIESEL_HYBRID = 'DIESEL_HYBRID',
  DIESEL_PLUGIN_HYBRID = 'DIESEL_PLUGIN_HYBRID',
  ELECTRICITY = 'ELECTRICITY',
  PETROL = 'PETROL',
  PETROL_HYBRID = 'PETROL_HYBRID',
  PETROL_PLUGIN_HYBRID = 'PETROL_PLUGIN_HYBRID',
  GAS = 'GAS',
  OTHER = 'OTHER',
}

export default VehicleLoanFuelTypeLabel;
